import { RESTError } from "../core/RESTError";

/**
 * An error that occurs when a user tries to log in with initial/incomplete token information, e.g. a code but no email
 * or if the user request data and does not provide a token.
 */
export class TokenInitialError extends RESTError {}
